module.exports = __webpack_public_path__ + "static/media/banner_slide02.111ec62b.png";